<template>
  <v-app>
    <v-content>
      <v-container fluid fill-height height="100%" class="pa-0">
        <v-layout fill-height>
          <v-flex id="welcomeImage" md7 hidden-sm-and-down> </v-flex>

          <v-flex text-xs-center>
            <v-container>
              <v-layout column class="loginArea">
                <v-flex>
                  <template v-if="$route.matched.length">
                    <router-view></router-view>
                  </template>
                </v-flex>
                <v-footer class="loginFooter" height="150">
                  <v-container class="">
                    <v-layout row wrap>
                      <v-flex class="text-xs-center mt-4">
                        <p>
                          <a href="https://www.rti.org" target="_blank"
                            ><v-img
                              src="~@/assets/RTI_Logo.svg"
                              aspect-ratio="2.5"
                              width="100"
                              alt="RTI International"
                              style="margin: auto"
                          /></a>
                        </p>
                        <p>
                          Amaze is a collaboration platform designed and
                          developed by RTI International and is an initiative of
                          <a
                            href="https://educationservices.rti.org"
                            target="_blank"
                            >RTI's Center for Education Services
                            <v-icon size="10" style="vertical-align: middle"
                              >fas fa-external-link-alt</v-icon
                            ></a
                          >. RTI International is a trade name of Research
                          Triangle Institute. RTI and the RTI logo are U.S.
                          registered trademarks of Research Triangle Institute.
                          &copy;{{ new Date().getFullYear() }} RTI
                          International.
                          <a
                            href="https://www.rti.org/privacy-policy"
                            target="_blank"
                            color="black"
                          >
                            Privacy Policy
                            <v-icon size="10" style="vertical-align: middle"
                              >fas fa-external-link-alt</v-icon
                            ></a
                          >
                          |
                          <a
                            href="https://www.rti.org/terms-use"
                            target="_blank"
                          >
                            Terms of Use
                            <v-icon size="10" style="vertical-align: middle"
                              >fas fa-external-link-alt</v-icon
                            ></a
                          >
                        </p>
                        <AmazeDevelopmentInfo/>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-footer>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
        <cookie-law theme="royal">
          <div slot-scope="props">
            <p class="py-0 my-0 pr-2" style="display: inline-block; width: 90%">
              RTI uses cookies to offer you the best experience online. By
              continuing to use our website, you agree to the use of cookies. If
              you would like to know more about cookies and how to manage them
              please view our
              <a
                href="https://www.rti.org/privacy-policy"
                target="_blank"
                color="black"
                >Privacy Policy</a
              >.
            </p>
            <v-btn
              class="px-0 py-0 ma-0 mt-2"
              style="display: inline-block; vertical-align: top"
              @click="props.accept"
              >I accept</v-btn
            >
          </div>
        </cookie-law>
      </v-container>
    </v-content>
    <amaze-snackbar></amaze-snackbar>
  </v-app>
</template>

<style scoped lang="scss">
@import "src/styles/variables.scss";

#welcomeImage {
  position: relative;
  background-position: center right;
  background-image: url("~@/assets/pencils.jpg");
  background-size: cover;
}
.loginArea {
}
.loginFooter {
  border-top: 1px solid #cacaca;
  background-color: #ffffff;
  font-size: 12px;
}

.Cookie--amaze {
  background-color: $amaze-yellow;
}
</style>

<script>
import CookieLaw from "vue-cookie-law";
import AmazeDevelopmentInfo from "@/components/Widgets/AmazeDevelopmentInfo";

export default {
  components: { CookieLaw, AmazeDevelopmentInfo },
  data: () => ({
    drawer: null
  })
};
</script>
